import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import * as Sentry from '@sentry/node'

const clientCredentials = {
  apiKey: process.env.FIREBASE_API_KEY || '',
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || '',
  databaseURL: process.env.FIREBASE_DATABASE_URL || '',
  projectId: process.env.FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.FIREBASE_APP_ID || '',
}
// Check that `window` is in scope for the analytics module!
// if (typeof window !== 'undefined' && !firebase.apps.length) {

const ahamomentClientCredentials = {
  apiKey: process.env.AHAMOMENT_FIREBASE_API_KEY || '',
  authDomain: process.env.AHAMOMENT_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.AHAMOMENT_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.AHAMOMENT_FIREBASE_STORAGE_BUCKET || '',
  databaseURL: process.env.AHAMOMENT_FIREBASE_DATABASE_URL || '',
  messagingSenderId: process.env.AHAMOMENT_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.AHAMOMENT_FIREBASE_APP_ID || '',
  measurementId: process.env.AHAMOMENT_FIREBASE_MEASUREMENT_ID || '',
}

const commentsCredentials = {
  apiKey: process.env.COMMENTS_FIREBASE_API_KEY || '',
  authDomain: process.env.COMMENTS_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.COMMENTS_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.COMMENTS_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.COMMENTS_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.COMMENTS_FIREBASE_APP_ID || '',
}

const premiumCoversCredentials = {
  apiKey: process.env.PREMIUM_COVERS_FIREBASE_API_KEY || '',
  authDomain: process.env.PREMIUM_COVERS_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.PREMIUM_COVERS_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.PREMIUM_COVERS_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId:
    process.env.PREMIUM_COVERS_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.PREMIUM_COVERS_FIREBASE_APP_ID || '',
}

if (!firebase.apps.length) {
  try {
    firebase.initializeApp(commentsCredentials, 'commentsFirebase')
    firebase.initializeApp(ahamomentClientCredentials, 'ahamomentFirebase')
    firebase.initializeApp(premiumCoversCredentials, 'premiumCoversFirebase')
    firebase.initializeApp(clientCredentials) // classroom chat
    // Firebase initialized successfully
  } catch (error) {
    Sentry.captureException(error)
  }
}

export default firebase

// Safely initialize Firestore and Database instances
let firestore,
  firebasedb,
  firestoreAhaMoment,
  firestoreComments,
  firestorePremiumCovers

try {
  firestore = firebase.firestore()
  firebasedb = firebase.database()

  // Only attempt to get specialized Firebase apps if they're initialized
  try {
    firestoreAhaMoment = firebase.app('ahamomentFirebase').firestore()
  } catch (e) {
    Sentry.captureMessage(
      'AhaMoment Firestore initialization failed: ' + e.message
    )
    firestoreAhaMoment = null
  }

  try {
    firestoreComments = firebase.app('commentsFirebase').firestore()
  } catch (e) {
    Sentry.captureMessage(
      'Comments Firestore initialization failed: ' + e.message
    )
    firestoreComments = null
  }

  try {
    firestorePremiumCovers = firebase.app('premiumCoversFirebase').firestore()
  } catch (e) {
    Sentry.captureMessage(
      'Premium Covers Firestore initialization failed: ' + e.message
    )
    firestorePremiumCovers = null
  }
} catch (e) {
  Sentry.captureException(e)
  // Provide fallbacks
  firestore = null
  firebasedb = null
  firestoreAhaMoment = null
  firestoreComments = null
  firestorePremiumCovers = null
}

export {
  firestore,
  firebasedb,
  firestoreAhaMoment,
  firestoreComments,
  firestorePremiumCovers,
}
